import { Headers, Http } from "@angular/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EzoomApiProvider } from "./ezoom-api";
import { GlobalProvider } from "./global";

/*
  Generated class for the TermoAutorizacaoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class entreJogoProvider {
    constructor(public api: EzoomApiProvider) {}

    public uploadFile(data: any) {
        return new Promise((resolve, reject) => {
            this.api
                .upload("gallery/upload", data)
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public insertToDb(data: any) {
        return new Promise((resolve, reject) => {
            this.api.post("gallery/insert", data).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/entreJogo.ts